import { createGlobalStyle } from 'styled-components'
import { PancakeTheme } from '@pancakeswap/uikit'

declare module 'styled-components' {
  /* eslint-disable @typescript-eslint/no-empty-interface */
  export interface DefaultTheme extends PancakeTheme {}
}

const GlobalStyle = createGlobalStyle`
  body {
    background-color: ${({ theme }) => theme.colors.background};

    img {
      height: auto;
      max-width: 100%;
    }
  }

  #__next {
    position: relative;
    z-index: 1;
  }

  #portal-root {
    position: relative;
    z-index: 2;
  }

  /* Bez's type rule (site review 59 #8, 2026-10-08): nothing under 12 px. <small> keeps its ratio (0.84 em) above the floor and never goes below it:
     a 12 px line's <small> was 10.08 px on the competition page. */
  small {
    font-size: max(0.84em, 12px);
  }
`

export default GlobalStyle
